import {SurveyService} from "../services/survey.service";

export const surveyInitializer =
		(surveyEnvironmentParameterValue: string, surveyService: SurveyService) => (): boolean => {
	surveyService.setSurveyEnvironmentParameter(surveyEnvironmentParameterValue);
	return true;
}